import { createFileRoute, Outlet, redirect } from '@tanstack/react-router'

import { CheckoutLayout } from '../../components/checkout/CheckoutLayout'
import { isAuthed } from '../../utils/jwt'

const PATH = '/booking'

export const Route = createFileRoute(PATH)({
    /**
     * Client-only, like everything authenticated here: the token lives in localStorage, which the
     * server cannot read, so an SSR pass would bounce a signed-in user to the login form and then
     * change its mind on hydration.
     */
    ssr: false,
    /**
     * UX rather than a security boundary — `isAuthed` only proves a token exists, not that it is
     * valid. Every procedure behind these screens is a userAuthenticatedProcedure, and a rejected
     * token is caught by the 401 handler in router.tsx.
     */
    beforeLoad: ({ location }) => {
        if (!isAuthed()) {
            throw redirect({ to: '/login', search: { redirect: location.href } })
        }
    },
    component: () => (
        <CheckoutLayout>
            <Outlet />
        </CheckoutLayout>
    ),
})
